import {
  DialogContent as MuiDialogContent,
  DialogContentProps,
} from "@mui/material";
import React from "react";

export default function DialogContent(props: DialogContentProps) {
  return <MuiDialogContent {...props} dividers />;
}
